import { BlockchainContext } from "pages/BlockchainContext";
import { useContext, useState, useEffect } from "react";

function Audit() {
  const { contractAddress, targetSymbol } = useContext(BlockchainContext);

  const handleClick = () => {
    alert("Coming soon");
  };

  return (
    <div className="widget-box">
      <div className="widget-header">AI Audit Report: {targetSymbol}</div>
      <div className="widget-content">
        Contract: {contractAddress}
        <br></br> Is the contract code safe?
        <br></br> What are the socials?
        <br></br> How much supply was added to liquidity?
        <br></br> How many tokens do the team own?
        <br></br> Are these tokens locked with a trusted source?
        <br></br> What are the unlock dates for team tokens and liquidity?
      </div>
      <div className="widget-button" onClick={handleClick}>
        Generate Audit {targetSymbol}
      </div>
    </div>
  );
}

export default Audit;
